import { Component, Input, OnInit } from '@angular/core';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';

@Component({
  selector: 'app-documento-dettaglio-metadato-modal',
  templateUrl: './documento-dettaglio-metadato-modal.component.html',
 
})
export class DocumentoDettaglioMetadatoModalComponent implements OnInit {

  documento: any;

  constructor(public dialogRef: DialogRef, private dialogConfig: DialogConfig) {}

  ngOnInit(): void {
    this.documento = this.dialogConfig?.data?.documento
    console.log('Documento ricevuto in modale:', this.documento);
  }

  getSoggettiString(): string {
    if(!this.documento?.soggetti) return '';
      return this.documento.soggetti.map(s => {
        let parts = [];
        if(s.nome) parts.push(s.nome);
        if(s.cognome) parts.push(s.cognome);
        if(s.tipoSoggetto) parts.push(s.tipoSoggetto);
        if(s.denominazione) parts.push(s.denominazione);
        return parts.join(' ');
      }).join(', ');
  }

}